import { render, staticRenderFns } from "./newTrial.vue?vue&type=template&id=5589e81a&scoped=true"
import script from "./newTrial.vue?vue&type=script&lang=js"
export * from "./newTrial.vue?vue&type=script&lang=js"
import style0 from "./newTrial.vue?vue&type=style&index=0&id=5589e81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5589e81a",
  null
  
)

export default component.exports